import { DeviceFamily } from '@amzn/fire-tv-campaign-automation-service';
import { STAGE } from 'src/constants';

const STAGE_DEVICE_FAMILY_CONFIG: Record<STAGE, DeviceFamily[]> = {
  [STAGE.DEV]: [DeviceFamily.FIRE_TV, DeviceFamily.FIRE_TABLETS],
  [STAGE.BETA]: [DeviceFamily.FIRE_TV, DeviceFamily.FIRE_TABLETS],
  [STAGE.GAMMA]: [DeviceFamily.FIRE_TV, DeviceFamily.FIRE_TABLETS],
  [STAGE.PROD_NA]: [DeviceFamily.FIRE_TV, DeviceFamily.FIRE_TABLETS],
};

export function getDeviceFamilyOptionsByStage(stage: STAGE) {
  const deviceFamilies = STAGE_DEVICE_FAMILY_CONFIG[stage];
  if (!deviceFamilies) return [];
  return deviceFamilies.map((deviceFamily) => ({
    name: deviceFamily,
    value: deviceFamily,
  }));
}
